import React, { Suspense } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from '../cart/services/store';
import Campaigns from './components/campaigns/Campaigns';
import SubmitIdea from './components/submit_idea/SubmitIdea';
import { campaignsActions } from './actions';

window.store = window.store || store;

document.addEventListener('DOMContentLoaded', () => {
  const elementId = 'react-campaigns-component';
  const data = JSON.parse(document.querySelector(`script[data-dom-id="${elementId}"]`).textContent);
  const { campaignsByCategory, categories } = data;
  window.store.dispatch(campaignsActions.setCategories(categories));
  window.store.dispatch(campaignsActions.setCampaignsByCategory(campaignsByCategory));

  hydrateRoot(
    document.getElementById(elementId),
    <Provider store={window.store}>
      <Campaigns />
    </Provider>,
  );

  const submitIdeaElement = document.getElementById('react-submit-idea');
  createRoot(
    submitIdeaElement,
  ).render(
    <SubmitIdea />,
  );

  const StickyCategories = React.lazy(() => import('../homepage/components/sticky_categories/StickyCategories'));
  createRoot(
    document.getElementById('react-sticky-categories'),
  ).render(
    <Suspense fallback="">
      <Provider store={window.store}>
        <StickyCategories />
      </Provider>
    </Suspense>,
  );
});
